import {
	CustomAppearance,
	FoxitFragments,
} from '@/components/documents/Foxit/FoxItCustomAppearance'
import { installHighResTypedSignatures } from '@/components/documents/Foxit/TypedSignatureRenderer'
import {
	PDFUI,
	PDFViewCtrl,
} from '@foxitsoftware/foxit-pdf-sdk-for-web-library'
import preloadJrWorker from '@foxitsoftware/foxit-pdf-sdk-for-web-library/lib/preload-jr-worker.js'

interface UiParams {
	renderTo: string
	viewerOptions: {
		libPath: string
		jr: { readyWorker: any }
		messageSyncServiceWorker: {
			url: string
			options: {
				scope: string
				type: string
			}
		}
	}
	addons?: string
	appearance?: any
	fragments?: any
}

const LICENSE_KEY = import.meta.env.VITE_FOXIT_PDF_SDK_LICENSE_KEY
const LICENSE_SN = import.meta.env.VITE_FOXIT_PDF_SDK_LICENSE_SN
const showToolbar = import.meta.env.VITE_SHOW_FOXIT_TOOLBAR === 'true'

let pdfui: PDFUI
let pdfViewer: PDFViewCtrl.PDFViewer

export const useFoxitInstance = () => {
	const getPdfui = () => {
		return pdfui
	}

	const getPdfViewer = () => {
		return pdfViewer
	}

	// Preloads the FoxIt PDF SDK and initializes the PDFUI and PDFViewer.
	const prepareUiandViewer = async (
		targetDiv: string = 'pdf-ui'
	): Promise<void> => {
		const readyWorker = await preloadJrWorker({
			workerPath: '/FoxitPDFSDKForWeb/lib/',
			enginePath: '../lib/jr-engine/gsdk',
			fontPath: '/FoxitPDFSDKForWeb/lib/jr-engine/FoxitFonts/',
			licenseSN: LICENSE_SN,
			licenseKey: LICENSE_KEY,
		})
		let uiParams: UiParams = {
			renderTo: `#${targetDiv}`,
			viewerOptions: {
				libPath: '/FoxitPDFSDKForWeb/lib',
				jr: { readyWorker: readyWorker },
				messageSyncServiceWorker: {
					url: '/service-worker.js',
					options: {
						scope: '/FoxitPDFSDKForWeb/lib/',
						type: 'module',
					},
				},
			},
		}

		if (showToolbar) {
			uiParams.addons = '/FoxitPDFSDKForWeb/lib/uix-addons/allInOne.js'
		} else {
			uiParams.appearance = CustomAppearance
			// @ts-ignore incorrectly typed in Foxit SDK
			uiParams.fragments = FoxitFragments
		}

		pdfui = new PDFUI(uiParams)
		pdfViewer = await pdfui.getPDFViewer()
		installHighResTypedSignatures()
	}

	return {
		getPdfui,
		getPdfViewer,
		prepareUiandViewer,
		showToolbar,
	}
}
